/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Gpestimatedticketsize_Modal_Maxatleastmin7Inputs */

const en_coinvestments_gpestimatedticketsize_modal_maxatleastmin7 = /** @type {(inputs: Coinvestments_Gpestimatedticketsize_Modal_Maxatleastmin7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Maximum must be at least the minimum`)
};

/**
* | output |
* | --- |
* | "Maximum must be at least the minimum" |
*
* @param {Coinvestments_Gpestimatedticketsize_Modal_Maxatleastmin7Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_gpestimatedticketsize_modal_maxatleastmin7 = /** @type {((inputs?: Coinvestments_Gpestimatedticketsize_Modal_Maxatleastmin7Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Gpestimatedticketsize_Modal_Maxatleastmin7Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_gpestimatedticketsize_modal_maxatleastmin7(inputs)
});
export { coinvestments_gpestimatedticketsize_modal_maxatleastmin7 as "coInvestments_gpEstimatedTicketSize_modal_maxAtLeastMin" }